var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPickAndMix(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13457_10110)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 50,
    fill: "#002069"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_13457_10110)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.2103 34.0937C41.2935 34.1321 41.3832 34.1449 41.4728 34.1449C41.6522 34.1449 41.8251 34.0745 41.9532 33.9464C42.2157 33.6838 42.2157 33.2547 41.9532 32.9921L38.1234 29.1624C37.9953 29.0343 37.8288 28.9639 37.6431 28.9639C37.4574 28.9639 37.2909 29.0343 37.1628 29.1624C37.0347 29.2905 36.9642 29.457 36.9642 29.6427C36.9642 29.8284 37.0347 29.995 37.1628 30.123L40.9925 33.9528C41.0566 34.0168 41.127 34.0617 41.2039 34.1001L41.2103 34.0937Z",
    fill: "#7BA0C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33 39.2175C33 39.4865 33.1601 39.7362 33.4099 39.8387C33.4931 39.8771 33.5828 39.8899 33.6724 39.8899H39.0905C39.4619 39.8899 39.7693 39.5889 39.7693 39.2111C39.7693 38.8332 39.4683 38.5322 39.0905 38.5322H33.6789C33.3074 38.5322 33 38.8332 33 39.2111V39.2175Z",
    fill: "#7BA0C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.9001 69.7853C45.7829 72.9234 49.2348 74.8767 52.8981 74.8767H56.6702C62.4596 74.8767 67.1668 70.1695 67.1668 64.3801V52.8716C67.1668 52.2376 66.917 51.642 66.4751 51.1937C66.0268 50.7454 65.4312 50.502 64.7972 50.502C62.1971 50.502 62.4276 54.5047 62.4276 55.1515H61.7488V51.1104C61.7488 50.406 61.4734 49.7399 60.9738 49.2404C60.4743 48.7409 59.8147 48.4655 59.1038 48.4655C56.7214 48.4655 56.4652 52.0263 56.4652 53.384H55.7864V49.0739C55.7864 48.3694 55.511 47.7034 55.0115 47.2038C54.5119 46.7043 53.8523 46.4289 53.1414 46.4289C50.7975 46.4289 50.5029 50.0473 50.5029 51.3474H49.824V37.559C49.824 36.8546 49.5486 36.1885 49.0491 35.689C48.5496 35.1894 47.8899 34.9141 47.1791 34.9141C47.115 34.9141 47.0574 34.9141 46.9933 34.9205C45.6164 35.0165 44.5405 36.2141 44.5405 37.6423V60.6016L40.73 54.2613C40.2496 53.4608 39.4043 52.9805 38.4629 52.9805C37.9825 52.9805 37.515 53.1086 37.1052 53.3583C35.8563 54.1076 35.4529 55.7343 36.2021 56.9832L43.8873 69.7725L43.9001 69.7853Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.6721 39.2175C54.6721 39.4865 54.8322 39.7362 55.0819 39.8387C55.1652 39.8771 55.2548 39.8899 55.3445 39.8899H60.7625C61.134 39.8899 61.4414 39.5889 61.4414 39.2111C61.4414 38.8332 61.1404 38.5322 60.7625 38.5322H55.3445C54.9731 38.5322 54.6656 38.8332 54.6656 39.2111L54.6721 39.2175Z",
    fill: "#7BA0C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.2239 31.7693C47.5953 31.7693 47.9027 31.4683 47.9027 31.0905V25.6789C47.9027 25.3074 47.6017 25 47.2239 25C46.846 25 46.545 25.301 46.545 25.6789V31.0969C46.545 31.3658 46.7052 31.6156 46.9549 31.7181C47.0382 31.7501 47.1278 31.7693 47.2175 31.7693H47.2239Z",
    fill: "#7BA0C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.7983 28.9639C56.619 28.9639 56.446 29.0343 56.318 29.1624L52.4882 32.9921C52.3601 33.1202 52.2897 33.2867 52.2897 33.4725C52.2897 33.6582 52.3601 33.8247 52.4882 33.9528C52.5522 34.0168 52.6227 34.0617 52.6995 34.0937C52.7828 34.1321 52.8725 34.1449 52.9621 34.1449C53.1414 34.1449 53.3144 34.0745 53.4424 33.9464L57.2722 30.1166C57.5348 29.8541 57.5348 29.425 57.2722 29.1624C57.1441 29.0343 56.9776 28.9639 56.7919 28.9639H56.7983Z",
    fill: "#7BA0C4"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13457_10110"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_13457_10110"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.1667,
    height: 49.87,
    fill: "white",
    transform: "translate(33 25)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPickAndMix);
export default __webpack_public_path__ + "static/media/pick_and_mix.ab474bf0fad82dc265b22dad2a15957c.svg";
export { ForwardRef as ReactComponent };